<template>
  <footer class="bdT ta-c p-30 lh-0 fsz-sm c-grey-600">
    <span>Copyright © 2018 Process Manager. All rights reserved.</span>
  </footer>
</template>

<script>

export default {
  name: 'footerbar',
  data() {
    return {
      name: ''
    }
  },
  methods: {
  },
  beforeMount() {
  },
  mounted() {
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footerbar.vue